import React, { createContext, useState, useContext, useCallback, useEffect } from 'react';
import { GetBrokerInfo, GetAvailableIps, GetMyBroker } from '../../services/backendServices'
import { toast } from 'react-toastify';
// Create the BrokerContext to share data across components
const BrokerContext = createContext();

export const BrokerContextProvider = ({ children }) => {
    const [brokerData, setBrokerData] = useState(null);
    const [isBrokerDataLoading, setIsBrokerDataLoading] = useState(false);
    const [isBrokerDataFetched, setIsBrokerDataFetched] = useState(false);
    const [availableIpOptions, setAvailableIpOptions] = useState([]);
    const [myDematData, setMyDematData] = useState(null);
    const [isMyDematDataLoading, setIsMyDematDataLoading] = useState(false);
    // Function  to fetch broekr  data 
    const fetchBrokerInfo = async (is_refresh = false) => {
        setIsBrokerDataLoading(true);
        try {
            const res = await GetBrokerInfo();
            if (res.status) {
                setBrokerData(res.data);
                setIsBrokerDataFetched(true);
                if (is_refresh) {
                    toast.success("Data refreshed successfully! ")
                }
            } else {
                if (is_refresh) {
                    toast.success(res.msg || 'Failed to fetch data')
                }
            }
        } catch (e) {
            console.error("Error fetching  broker info:", e);
        } finally {
            setIsBrokerDataLoading(false);
        }
    };
    // Function to fetch available IPs
    const fetchAvailableIps = async (Values) => {
        try {
            const res = await GetAvailableIps(Values);
            if (res.status && Array.isArray(res.data)) {

                const options = res.data.map(ip => ({
                    value: ip.id,
                    label: ip.ip_address
                }));
                // Set the available IP options
                setAvailableIpOptions(options);

            } else {
                // Set the available IP options to empty array
                setAvailableIpOptions([]);
                // Log the error if the API call fails
                console.log("Failed to fetch IPs or response format incorrect");
            }
        } catch (e) {
            // Log the error if the API call fails
            console.error("Error fetching available IPs", e);
        }
    };

    //Function for Get My Broker 
    const GetMyBrokerApiCall = async () => {
        setIsMyDematDataLoading(true);
        try {
            const res = await GetMyBroker();
            if (res.status) {
                setMyDematData(res.data);
            } else {
                toast.error(res.msg);
            }
        } catch (error) {
            console.log(error.message);
        } finally {
            setIsMyDematDataLoading(false);
        }
    }


    return (
        // Provide account data and functions to child components
        <BrokerContext.Provider
            value={{ brokerData, setBrokerData, isBrokerDataFetched, fetchBrokerInfo, isBrokerDataLoading, setIsBrokerDataFetched, fetchAvailableIps, availableIpOptions, setAvailableIpOptions, myDematData, GetMyBrokerApiCall, isMyDematDataLoading }} >
            {children}
        </BrokerContext.Provider>
    );
};

// Custom hook to easily access BrokerContext in other components
export const useBrokerContext = () => {
    return useContext(BrokerContext);
};
